module.exports = require('./isRouteObject')
